/** §7.1: three primary stockpiles. */
export type StockpileResource = "PROVISIONS" | "TREASURY" | "RESERVES";
export const STOCKPILE_RESOURCES: readonly StockpileResource[] = [
  "PROVISIONS",
  "TREASURY",
  "RESERVES",
] as const;

/** §7.2: five raw industrial-material families. */
export type IndustrialMaterial =
  | "MECHANICAL"
  | "PRECISION"
  | "ELECTRONIC"
  | "CHEMICAL"
  | "LIGHT_INDUSTRY";
export const INDUSTRIAL_MATERIALS: readonly IndustrialMaterial[] = [
  "MECHANICAL",
  "PRECISION",
  "ELECTRONIC",
  "CHEMICAL",
  "LIGHT_INDUSTRY",
] as const;

/** §7.3: crate quality ladder. */
export type CrateTier = "COPPER" | "SILVER" | "GOLD" | "PLATINUM";
export const CRATE_TIERS: readonly CrateTier[] = ["COPPER", "SILVER", "GOLD", "PLATINUM"] as const;

/** §7.6: premium currency — diamonds buy speed-ups + premium items. */
export type PremiumCurrency = "DIAMONDS";

/** §7.5: inventory categories (left-rail tab list). */
export type InventoryCategory =
  | "RESOURCES"
  | "SPEED_UPS"
  | "BOOSTS"
  | "OFFICER_ITEMS"
  | "TACTICS_ITEMS"
  | "OTHER";
export const INVENTORY_CATEGORIES: readonly InventoryCategory[] = [
  "RESOURCES",
  "SPEED_UPS",
  "BOOSTS",
  "OFFICER_ITEMS",
  "TACTICS_ITEMS",
  "OTHER",
] as const;
